module.exports = __webpack_public_path__ + "42e863d7.ttf";